import React, { useState, createContext } from "react";

export const ScoreContext = createContext();

export const SubmitButtonContext = createContext();
